var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.986 0 0.5 4.486 0.5 10C0.5 15.514 4.986 20 10.5 20C16.014 20 20.5 15.514 20.5 10C20.5 4.486 16.014 0 10.5 0ZM2.5 10C2.5 9.101 2.656 8.238 2.931 7.431L4.5 9L6.5 11V13L8.5 15L9.5 16V17.931C5.561 17.436 2.5 14.072 2.5 10ZM16.83 14.873C16.177 14.347 15.187 14 14.5 14V13C14.5 12.4696 14.2893 11.9609 13.9142 11.5858C13.5391 11.2107 13.0304 11 12.5 11H8.5V8C9.03043 8 9.53914 7.78929 9.91421 7.41421C10.2893 7.03914 10.5 6.53043 10.5 6V5H11.5C12.0304 5 12.5391 4.78929 12.9142 4.41421C13.2893 4.03914 13.5 3.53043 13.5 3V2.589C16.428 3.778 18.5 6.65 18.5 10C18.4998 11.7647 17.9123 13.4791 16.83 14.873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.4ec61d0276827324ae7407a43a87dd9f.svg";
export { ForwardRef as ReactComponent };